import styled from 'styled-components';

export const MainWrapperLogin = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:${props.theme.spacing.large.l20};
    `
);

export const DividerWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        position: relative;
        margin: ${props.theme.spacing.large.l50} ${props.theme.spacing.nospacing};
        height: 1px;
        background-color: ${props.theme.colors.grey.base1};
`);

export const OrWrapper = styled.div(
    props => `
        width: 3.6rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.grey.light1};
        border: 1px solid ${props.theme.colors.grey.base1};
        border-radius: ${props.theme.misc.borderRadius.round};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.light5};
        font-weight: ${props.theme.font.fontWeight.bold};
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -1.8rem;
        z-index:${props.theme.misc.zIndex.xxlarge};
`);

export const LoginOtpWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LoginOtpText = styled.a(
    props => `
        font-size:${props.theme.font.large.font16};
        font-weight: ${props.theme.font.fontWeight.bold};
        color: ${props.theme.colors.blue.base};
        cursor: pointer;
`);

export const ResendBlock = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;

      @media only screen and (min-width:320px) and (max-width: 768px){
          padding-top: 0rem;
          justify-content: flex-end;
      }

      @media only screen and (min-width:1025px) and (max-width: 1300px){
          justify-content: flex-end;
      }
  `,
);

export const ResendText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `,
)

export const StronInfoWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding-top: ${props.theme.spacing.small.s5};
  `
);

export const StrongHeadText = styled.p(
  props => `
    width:100%;
    display: flex;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const StrongSubText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.light9b};
    line-height: ${props.theme.font.lineHeight.base};
  `
);

export const TickIconWrapper = styled.div(
  props => `
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props.theme.colors.green.dark};
    border-radius: ${props.theme.misc.borderRadius.round};
    position: absolute;
    top: 2.1rem;
    right: 1rem;
    transform: translateY(-50%);
  `
);

export const TickErrorIconWrapper = styled.div(
  props => `
    width: 1.3rem;
    height: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props.theme.colors.red.base};
    border-radius: ${props.theme.misc.borderRadius.round};
    position: absolute;
    top: 2.1rem;
    right: 1rem;
    transform: translateY(-50%);
  `
);

export const CloseIco = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font8};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const EyeWrapper = styled.div(
  props => `
    position: absolute;
    height: 42px;
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const StrongPassInfo = styled.div(
  props => `
    position: absolute;
    height: 42px;
    border-right: 4px solid ${props.theme.colors.green.dark};
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const StongText = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.green.dark};
    font-weight: ${props.theme.font.fontWeight.bold};
    display: flex;
    padding-top: ${props.theme.spacing.large.l13};
    padding-right: ${props.theme.spacing.large.l45};
  `
);

export const StrongFailInfo = styled.div(
  props =>`
    position: absolute;
    height: 42px;
    border-right: 4px solid ${props.theme.colors.red.base};
    right: 0;
    top: 0;
    display: flex;
    aling-items: center;
    justidy-content: center;
    border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
  `
);

export const WeakText = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.red.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    display: flex;
    padding-top: ${props.theme.spacing.large.l13};
    padding-right: ${props.theme.spacing.large.l45};
  `
);

export const UserImportantInfoWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    margin-top: ${props.theme.spacing.large.l20};
    flex-direction: column;
  `,
);

export const UserConsentText = styled.label(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    cursor: pointer;
  `,
);

export const UserTermsText = styled.span(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.base};
  `
);

export const UserTermsCheck = styled.input.attrs({type: 'checkbox'})(
  props =>`
    display: inline-flex;
    margin-right: 0.5rem;
    cursor: pointer;
    vertical-align: middle;
    position: relative;
    top: -1.5px;
  `
);